export default "__VITE_ASSET__19e252b2__"